import { useCallback, useEffect, useState } from "react";

declare const window: any;

const useHeaderState = () => 
{
    const [ show, setShow ] = useState(false);

    const getViewPosition = useCallback(() => 
    {
        if (window.scrollY >= 60) 
        {
            setShow(true);
        }
        else 
        {
            setShow(false);
        }

    }, [ show ]);

    useEffect(() => 
    {
        window.addEventListener("scroll", getViewPosition, false);

        return () => 
        {
            window.removeEventListener("scroll", getViewPosition, false);
        };

    }, []);

    return show;
};

export default useHeaderState;
